import { audioContext as audioCtx, resumeAudioContext } from "../states/audioCtx";

let oscillator: OscillatorNode | undefined;
let gainNode: GainNode | undefined;
let generation = 0;

function cleanupNodes(): void {
  try {
    oscillator?.stop();
  } catch {
    // noop
  }
  try {
    gainNode?.disconnect();
  } catch {
    // noop
  }
  oscillator = undefined;
  gainNode = undefined;
}

export async function startEmptyAudioTrack(): Promise<void> {
  if (!audioCtx) return;
  const myGeneration = ++generation;
  cleanupNodes();
  if (audioCtx.state !== "running") {
    await resumeAudioContext();
  }
  if (myGeneration !== generation || !audioCtx) return;

  oscillator = audioCtx.createOscillator();
  oscillator.frequency.value = 0.1;

  gainNode = audioCtx.createGain();

  oscillator.connect(gainNode);

  gainNode.connect(audioCtx.destination);

  gainNode.gain.linearRampToValueAtTime(0.001, audioCtx.currentTime + 1);

  oscillator.start(audioCtx.currentTime + 1.1);
}

export function endEmptyAudioTrack(): void {
  generation++;
  cleanupNodes();
}
